import { defineStore as l } from "pinia";
import { ref as o } from "vue";
const s = l("ds-form", () => {
  const r = o(null), n = o(null), t = o(null), e = o(null);
  return {
    countryCode: r,
    countryMaskFile: n,
    countryValidatorFile: t,
    language: e
  };
});
export {
  s as useFormStore
};
